/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { TextArea } from 'sarsaparilla';
import { getValidationErrorStyle } from '../../utils/utilsNew';

export default class GenericCommentBox extends React.Component {
    static propTypes = {
        text: PropTypes.string,
        handleTextChange: PropTypes.func.isRequired,
        validation: PropTypes.object,
        isRequired: PropTypes.bool,
        validationTarget: PropTypes.string,
        instructionText: PropTypes.string,
        title: PropTypes.string.isRequired,
        placeholderText: PropTypes.string,
    };

    handleChange(event) {
        const comment = event.target.value;
        this.props.handleTextChange(comment);
    }

    render() {
        const validationClass =
            get(this.props, 'validationTarget', '') && get(this.props, 'validation', {})
                ? getValidationErrorStyle(
                      this.props.validation,
                      this.props.validationTarget,
                      'permit-validation-highlight'
                  )
                : '';

        return (
            <div className={`per-comment-form per-section-group ${validationClass}`}>
                <div className="rec-order-detail-subsection-title">
                    {this.props.title}
                </div>
                <p className="per-comment-form-instruction">
                    {this.props.instructionText}
                </p>
                <TextArea
                    placeholder={this.props.placeholderText}
                    id={`${this.props.title} text-area-1`}
                    label={this.props.title}
                    value={this.props.text}
                    onChange={(e) => {
                        this.handleChange(e);
                    }}
                    isRequired={this.props.isRequired}
                    className="rec-order-detail-comment-box"
                />
            </div>
        );
    }
}
